import React, { useState } from "react";
import { Row } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { editIcon, viewIcon } from "../../assets/img";

const UserBooking = ({
  bookings,
  setBookingPage,
  paginationBooking,
  rowBooking,
  bookingCount,
  getBookings,
  bookingStatus,
  serviceType,
  bookingCurrentStatus,
  bookingSearch,
}) => {
  const navigate = useNavigate();

  const handlePageChange = (selectedObject) => {
    setBookingPage(selectedObject.selected + 1);
  };

  return (
    <div>
      {" "}
      <Row md={12} sm={12} lg={12}>
        <div className="col-md-6 mt-5">
          <label className="table-labels f1">
            Total Count : {paginationBooking?.total}
          </label>
        </div>
      </Row>
      <div className="d-flex ac-jb ">
        <div className="col-md-2 p-0">
          <select
            className="form-control custom-select"
            onChange={(e) =>
              getBookings(
                e.target.value,
                bookingStatus,
                bookingCurrentStatus,
                bookingSearch
              )
            }
            value={serviceType}
          >
            <option value={""}>Service Type</option>
            <option value="room_booking">Room Booking</option>
            <option value="room_sharing">Room Sharing</option>
            <option value="get_to_gether">Get to gether</option>
            <option value="just_walking">Just Walking</option>
            <option value="day_outing">Day Outing</option>
          </select>
        </div>
        <div className="col-md-2 p-0">
          <select
            className="form-control custom-select"
            onChange={(e) =>
              getBookings(
                serviceType,
                e.target.value,
                bookingCurrentStatus,
                bookingSearch
              )
            }
            value={bookingStatus}
          >
            <option value={""}>Status</option>
            <option value="1">Booked</option>
            <option value="3">Cancelled</option>
          </select>
        </div>
        <div className="col-md-2 p-0">
          <select
            className="form-control custom-select"
            onChange={(e) =>
              getBookings(
                serviceType,
                bookingStatus,
                e.target.value,
                bookingSearch
              )
            }
            value={bookingCurrentStatus}
          >
            <option value="">Current Status</option>
            <option value="true">Check In</option>
            <option value="false">Check Out</option>
          </select>
        </div>
        <div className="col-md-4 p-0">
          <input
            className="form-control bg-white"
            placeholder="Eg: Booking Id"
            onChange={(e) =>
              getBookings(
                serviceType,
                bookingStatus,
                bookingCurrentStatus,
                e.target.value
              )
            }
            value={bookingSearch}
          />
        </div>
      </div>
      <div className="table-custom-design overflow-scroll">
        <table>
          <thead className="single-book-table">
            <tr className="text-capitalize">
              <th>S.NO</th>
              <th>Booking ID</th>
              <th>Property Name</th>
              <th>Category</th>
              <th>Status</th>
              <th>Current Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {bookings?.map((item, ind) => {
              return (
                <tr key={ind}>
                  <td>
                    {(paginationBooking?.current_page - 1) * rowBooking +
                      ind +
                      1}
                  </td>
                  <td>
                    <button
                      className="link-btn"
                      onClick={() =>
                        navigate("/booked-rooms-view", {
                          state: { type: "view", data: item },
                        })
                      }
                    >
                      {item?.booking_id}
                    </button>
                  </td>
                  <td>
                    <button
                      className="link-btn"
                      onClick={() => {
                        navigate("/property-view", {
                          state: {
                            type: "edit",
                            data: item?.property,
                          },
                        });
                      }}
                    >
                      {item?.property?.name}
                    </button>
                  </td>
                  <td>{item?.service_type}</td>
                  <td
                    className={`${
                      item?.booking_status == 3 ? "text-danger" : "text-success"
                    }`}
                  >
                    {item?.booking_status == 1
                      ? "Booked"
                      : item?.booking_status == 3
                      ? "Cancelled"
                      : item?.booking_status == 2
                      ? "Pending"
                      : "Initiated"}
                  </td>
                  <td>
                    {item?.check_out != null
                      ? "Check out"
                      : item?.check_in != null
                      ? "Check In"
                      : "-"}
                  </td>
                  <td>
                    <button
                      className="cust-btn"
                      onClick={() =>
                        navigate("/booked-rooms-view", {
                          state: { type: "view", data: item },
                        })
                      }
                    >
                      <img src={viewIcon} className="edit-btn" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="page-inner-cont py-2 d-flex justify-content-end">
        <ReactPaginate
          nextLabel="››"
          onPageChange={handlePageChange}
          pageRangeDisplayed={2}
          marginPagesDisplayed={2}
          pageCount={bookingCount}
          previousLabel="‹‹"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          renderOnZeroPageCount={null}
        />
      </div>
    </div>
  );
};

export default UserBooking;
